import React from 'react';
import MarkdownViewer from './MarkdownViewer';

function SupplierAgreement() {
  return (
    <MarkdownViewer
      title="Supplier Agreement"
      fileName="SUPPLIER_AGREEMENT.md"
    />
  );
}

export default SupplierAgreement;
